import Validator from "./validator"

const Storage = {
    setValue: (key, value) => {
        localStorage.setItem(key, value)
    },
    getValue: (key) => {
        return localStorage.getItem(key)
    },
    setObject: (key, object) => {
        localStorage.setItem(key, JSON.stringify(object))
    },
    getObject: (key) => {
        return JSON.parse(localStorage.getItem(key))
    },
    remove: (key) => {
        localStorage.removeItem(key)
    }
}

export default Storage